export default "__VITE_ASSET__CJljtxu3__";